export default __webpack_public_path__ + "static/1140-ca934a80e6e144d582b046521d68ae2e.gif";